import axios from "axios";

const Url = process.env.REACT_APP_URl;

export interface TokenPayload {
    password: string
    email: string
}

export const login = (user: TokenPayload) => {
    return axios.post(`${Url}/login`, user).then((response) => {
        localStorage.setItem('id', response.data.user._id)
        localStorage.setItem('usertoken', response.data.token)
        return response.data;
    });
};


export const saveToken = (token: any) => {
    localStorage.setItem('usertoken', token)
}

export const logout = () => {
    isLogged();
    localStorage.clear();
}

export const isLogged = () => {
    let token = localStorage.getItem('usertoken')
    return !!token
}

export const getCheckToken = async () => {
    const token = localStorage.getItem('usertoken');
    if (!token) return false;
    try {
        const response = await axios.get(`${Url}/check-token`, {
            headers : {    Authorization: `Bearer ${token}` }
        });
        // Token is valid – return true or the response data
        return response.data || true;
    } catch (error: any) {
        // Check if the error is due to an invalid/expired token (401)
        if (error.response && error.response.status === 401) {
            // Invalid/expired token – clear localStorage
            localStorage.removeItem('usertoken');
            return false;
        }
        // Other errors (network, server, etc.)
        console.error('Error while verifying the token:', error);
        return false;
    }
}
export const getCheckPDFToken = async (token: string) => {
    if (!token) return false;
    try {
        const response = await axios.get(`${Url}/check-token`, {
            headers : {    Authorization: `Bearer ${token}` }
        });
        // Token is valid – return true or the response data
        return response.data || true;
    } catch (error: any) {
        // Other errors (network, server, etc.)
        console.error('Error while verifying the token:', error);
        return false;
    }
}